module.exports = __webpack_public_path__ + "img/live_active_icon.bbe6e23b.png";